import React from 'react';
import { getValidationError } from '../functions/common';
const ValidationMessage = React.memo((props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("p", { className: `mt-2 text-red-500 text-xs italic ml-2 h-2.5 ${props.absoluteOff ? "" : 'absolute'}` }, getValidationError(props.name, props.validationErrors))));
});
export default ValidationMessage;
